import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UsuarioService } from '../services/usuario/usuario.service';

@Injectable({
  providedIn: 'root'
})
export class RolGuard implements CanActivate {

  constructor(private usuarioService: UsuarioService, private router: Router) {}

  canActivate(): boolean {
    const roles = this.usuarioService.getRoles();
    if (roles &&  (!roles.includes('EJECUTOR') && !roles.includes('JEFE DE SECCIÓN') && !roles.includes('ANALISTA DE MANTENIMIENTO'))){
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
